import { render, staticRenderFns } from "./TranslateColumn.vue?vue&type=template&id=4e43dec4&scoped=true&"
import script from "./TranslateColumn.vue?vue&type=script&lang=js&"
export * from "./TranslateColumn.vue?vue&type=script&lang=js&"
import style0 from "./TranslateColumn.vue?vue&type=style&index=0&id=4e43dec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43dec4",
  null
  
)

export default component.exports